module.exports = __webpack_public_path__ + "static/media/back-change-coin.bb87f8da.png";